// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"bebd1e88","96":"e4e4920b","307":"34e7d245","686":"d229b3e8","739":"e4e4920b"}[chunkId] + ".chunk.css";
};